import { getMonthlyOptions } from 'pages/addMoneyPool/moneyPool/memberShip/utils/indx'
import React from 'react'
interface IMntItemProps {
    setDateValue: React.Dispatch<React.SetStateAction<number>>
    onHide: () => void
}
export default function MntItem({ setDateValue, onHide }: IMntItemProps) {
    const monthlyOptions = getMonthlyOptions()
    return (
        <div>
            {monthlyOptions.map((item, index) => (
                <div
                    key={index}
                    className=" text-center my-2"
                    onClick={() => {
                        setDateValue(Number(item.value))
                        onHide()
                    }}
                >
                    {item.label}
                </div>
            ))}
        </div>
    )
}
